"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const parcel_1 = __importDefault(require("@becrop/components/Results/DistroTool/controllers/services/parcel"));
const vue_property_decorator_1 = require("vue-property-decorator");
let BreakdownOfFields = class BreakdownOfFields extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.fieldToSearch = '';
        this.fieldNamePreSelect = '';
        this.filteredFoundFields = this.fields;
    }
    /*     @Watch('fields')
        updatedFields() {
            this.filteredFoundFields = this.fields;
        } */
    updated() {
        this.filteredFoundFields = this.fields;
    }
    mounted() {
        this.filteredFoundFields = this.fields;
    }
    get fieldLevelsMap() {
        const levelsMap = {};
        for (const field of this.fields) {
            let found = { level: 0, max_level: 4 };
            for (const recommendation of field.recommendations) {
                if (recommendation.needMap === this.needMap.category.slug) {
                    for (const product of recommendation.products) {
                        if (product.product.toUpperCase() === this.productRecommendationName.toUpperCase()) {
                            found = {
                                level: product.level,
                                max_level: product.max_level !== undefined ? product.max_level : 4
                            };
                            break;
                        }
                    }
                }
            }
            levelsMap[`${field.id}`] = found;
        }
        return levelsMap;
    }
    parcelSvg(polygon) {
        return (0, parcel_1.default)(polygon, 30, 30);
    }
    emitFieldNamePreSelect(name) {
        this.fieldNamePreSelect === name ? this.fieldNamePreSelect = '' : this.fieldNamePreSelect = name;
        this.$emit('fieldNamePreSelect', this.fieldNamePreSelect);
    }
    onSearchField(f) {
        this.filteredFoundFields = this.fields.filter((fi) => fi.name.toLowerCase().includes(f.toLowerCase()));
        if (this.filteredFoundFields.length === 1) {
            this.emitFieldNamePreSelect(`${this.filteredFoundFields[0].name.toString()}${this.filteredFoundFields[0].id.toString()}`);
        }
    }
    updateFieldActiveKey(f) {
        this.$emit('updateFieldActiveKey', f);
    }
    findGisField(name) {
        if (!this.gisFields)
            return null;
        return this.gisFields.find((item) => `${item.name}${item.id}` === name);
    }
    getFieldStyle(field) {
        var _a;
        let color = '#787573';
        const gisField = this.findGisField(`${field.name.toString()}${field.id.toString()}`);
        if (gisField) {
            const needMapResult = (_a = gisField.needs_maps_results) === null || _a === void 0 ? void 0 : _a.find((needMapResult) => needMapResult.category.slug === this.needMap.category.slug);
            if (needMapResult) {
                // LOW=[0,40) MID=[40, 60) HIGH[60, ...)
                const colorScale = ['#E6D581', '#FF9A51', '#E52721'];
                const stats = needMapResult.results.stats;
                if (stats) {
                    const mean = stats.mean;
                    if (mean > 0 && mean < 40) {
                        color = needMapResult.category.reverseScale ? colorScale[2] : colorScale[0];
                    }
                    else if (mean >= 40 && mean < 60) {
                        color = needMapResult.category.reverseScale ? colorScale[1] : colorScale[1];
                    }
                    else if (mean >= 60) {
                        color = needMapResult.category.reverseScale ? colorScale[0] : colorScale[2];
                    }
                }
            }
        }
        return {
            stroke: color,
            fill: color + '50'
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Array, default: [] })
], BreakdownOfFields.prototype, "fields", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Array, default: [] })
], BreakdownOfFields.prototype, "gisFields", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], BreakdownOfFields.prototype, "needMap", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '---' })
], BreakdownOfFields.prototype, "productRecommendationName", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '---' })
], BreakdownOfFields.prototype, "areaName", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '---' })
], BreakdownOfFields.prototype, "fieldActiveKey", void 0);
BreakdownOfFields = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: { Rating: bmk_ui_framework_1.Rating, Search: bmk_ui_framework_1.Search }
    })
], BreakdownOfFields);
exports.default = BreakdownOfFields;
